.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  max-width: 880px;
  margin: 0 auto;
}
